import { useQuery } from '@tanstack/react-query';
import { channelsApi } from '../services';
import type { ChannelQuery } from '@troia-v3/types';

/**
 * Hook to fetch all channels with optional query filters
 *
 * @example
 * const { data, isLoading } = useChannels({ page: 1, limit: 10 });
 */
export const useChannels = (query?: ChannelQuery) => {
  return useQuery({
    queryKey: ['channels', query],
    queryFn: () => channelsApi.getAll(query),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
